<img class="product-image" :src="src" width="200" height="200">